module.exports = __webpack_public_path__ + "static/hamptons-e677ec3556d4189f496c11732f938c5c.jpg";